import { render, staticRenderFns } from "./RouteMapCountryWithPointsBlock.vue?vue&type=template&id=54d20eeb&"
import script from "./RouteMapCountryWithPointsBlock.vue?vue&type=script&lang=js&"
export * from "./RouteMapCountryWithPointsBlock.vue?vue&type=script&lang=js&"
import style0 from "./RouteMapCountryWithPointsBlock.vue?vue&type=style&index=0&id=54d20eeb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports